import {collection, EntityData, field, identifier} from "@fedeltapointofsale/data-client";
import {MetaTagDefinitionReferenceData} from "../../catalogue/meta-tag/meta-tag.data";

export class OrderReadyDisplayData extends EntityData<OrderReadyDisplayData> {
    @identifier id: number;
    @field name: string;
    @field title: string;
    @field site: string;
    @collection() outletIds: number[];
    @collection() terminalIds: number[];
    @collection() webTerminalIds: number[];
    @field matchUnqualified: boolean = false;
    @collection(MetaTagDefinitionReferenceData) orderReadyQualifiers: MetaTagDefinitionReferenceData[];
    @field displayTakeawayOrders: boolean = true;
    @field displayTableOrders: boolean = true;
    @field backgroundImage: string;
    @field backgroundImageOpacity: number;
    @field orderOverdueMinutes: number = 5;
}
